import { finishedGoodFilterUserPath } from "~/routes";

import { createSearchStore } from "./create-search-store";

export const useFinishedGoodSearch = createSearchStore({
  path: finishedGoodFilterUserPath,
  resultsKey: "finished_goods",
});
